<script>
import { authComputed } from '@store/helpers'

export default {
  name:"index2",
  page() {
    return {
      title: '登入',
    }
  },
  components: {
    Layout: () => import("@layout/main"),
    FormLogin: () => import("@components/Form/FormLogin"),
  },
  computed: {
    ...authComputed,
  },
  methods: {
    onSubmitCallback() {
      const shouldOpenDialogLineNotify = () => {
        const isBound = this.currentMember?.lineInfo.isBindLineNotify
        const invisibleDialog = this.$store.state.auth.currentInvisibleDialogLineNotify
        return !isBound && !invisibleDialog
      }

      if (this.$route.query.redirectFrom) {
        const redirectFrom = this.$route.query.redirectFrom
        const url = new URL(`${window.location.origin}${redirectFrom}`)
        url.searchParams.set('dialogDialogLineNotifyVisible', true)

        window.location = shouldOpenDialogLineNotify() ? url : redirectFrom
      } else {
        window.location = `/member${shouldOpenDialogLineNotify() ? '?dialogDialogLineNotifyVisible=true' : ''}`
      }
    }
  }
}
</script>
<!-- section template -->
<template>
  <Layout :class="$style.viewLogin">
    <BaseBannerJtails
      title="登入"
      description="為確保你的資訊安全，請進行手機驗證"
      :image="require(`@assets/images/${$globalProjectName}/member/banner@2.jpg`)"
    />
    <section :class="$style.sectionLogin" class="section">
      <div class="container--form">
        <FormLogin
          type="page"
          @submitCallback="onSubmitCallback"
        />
      </div>
    </section>
  </Layout>
</template>
<!-- section style -->
<style lang="scss" module>
.viewLogin {
  :global {
    .viewLogin {
      @include unstyled;
    }
  }
}

.sectionLogin {
  min-height: calc((var(--vh, 1vh) * 100) - 789px);

  :global {
    .sectionLogin {
      @include unstyled;
    }
  }
}
</style>
